import { useState, useEffect } from 'react'

const useActiveElement = () => {
  const [active, setActive] = useState(document.activeElement)

  const handleFocusIn = (e) => {
    setActive(e.target)
  }

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn)
    return () => {
      document.removeEventListener('focusin', handleFocusIn)
    }
  }, [])

  return active
}

export default useActiveElement
